require("./a-title-giant.scss");


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/atom/a-title-giant/a-title-giant.chunk.js